export { default } from './ProfileCardsPage'



// WEBPACK FOOTER //
// ./src/App/ProfileCardsPage/index.js